import { defaultRol, defaultFilterWorkRoles } from "./state";

/**
 * Mutación que pone por defecto el rol.
 *
 * @param {*} state.rol - El estado del rol.
 * @returns {void}
 * @author Brandon Torres
 */
export function setRolDefault(state) {
    state.rol = defaultRol();
}

/**
 * Mutación que establece los roles.
 *
 * @param {*} state.workRoles - El estado de los roles.
 * @param {*} roles - Los roles.
 * @returns {void}
 * @autor Brandon Torres
 */
export function setWorkRoles(state, roles) {
    state.workRoles = roles;
}

/**
 * Mutación que establece el paginador de registros de roles.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterWorkRoles.page - Página actual.
 * @param {*} state.filterWorkRoles.per_page - Cantidad de registros por página.
 * @param {*} state.filterWorkRoles.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateWorRoles(state, paginate) {
    state.filterWorkRoles = {
        ...state.filterWorkRoles,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la cantidad de roles por página.
 *
 * @param {*} state.filterWorkRoles.per_page - Cantidad de registros por página.
 * @param {*} state.filterWorkRoles.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterWorkRoles = {
        ...state.filterWorkRoles,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterWorkRoles.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterWorkRoles.page = page;
}

/**
 * Mutación que establece el filtro de roles por defecto.
 *
 * @param {*} state.filterWorkRoles - Estado del filtro de roles.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterWorRoles(state) {
    state.filterWorkRoles = defaultFilterWorkRoles();
}

/**
 * Mutación que establece el rol.
 *
 * @param {*} state.rol - Estado del rol.
 * @param rol - Rol.
 * @return {void}
 * @author Brandon Torres
 */
export function setRol(state, rol) {
    state.rol = rol;
}

/**
 * Mutación que establece los roles activos.
 *
 * @param {*} state.workRolesActive - Estado de los roles activos.
 * @param roles - Roles activos.
 * @return {void}
 * @autor Brandon Torres
 */
export function setWorkRolesActive(state, roles) {
    state.workRolesActive = roles;
}
